var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',_vm._g(_vm._b({},'v-form',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",null,null,{modified: _vm.modified, wasModified: _vm.wasModified})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }